import type { TTemplateAudienceProblem } from 'types/template/templateAudience.types';

const isFixedBySharing = (problem: TTemplateAudienceProblem, questionId: string) =>
  problem.kind === 'question'
    ? problem.questionId === questionId && problem.reason === 'missingAccessGroups'
    : problem.targetQuestionId === questionId && problem.issue === 'target_shares_no_access_group';

export function questionsSharingCanFix(problems: ReadonlyArray<TTemplateAudienceProblem>): string[] {
  const questionIds = problems.flatMap((problem) => {
    if (problem.kind === 'question') return problem.reason === 'missingAccessGroups' ? [problem.questionId] : [];
    return problem.issue === 'target_shares_no_access_group' ? [problem.targetQuestionId] : [];
  });
  return [...new Set(questionIds)];
}

export function withoutProblemsFixedBySharing(
  problems: ReadonlyArray<TTemplateAudienceProblem>,
  sharedQuestionIds: ReadonlyArray<string>,
): TTemplateAudienceProblem[] {
  return problems.filter((problem) => !sharedQuestionIds.some((questionId) => isFixedBySharing(problem, questionId)));
}
